module.exports = __webpack_public_path__ + "img/logo_idx_channel.a103bf47.png";